import { getEventOrganizationName } from './eventOrganization';

// Lightweight analytics helper for the site's Google Tag Manager / GA4 setup.
export function trackEvent(eventName, params = {}) {
  try {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...params });
  } catch {
    // Do nothing if analytics is not available
  }
}

export function trackFavoritesAdd(params) {
  trackEvent('favorites_add', params);
}

export function trackFavoritesRemove(params) {
  trackEvent('favorites_remove', params);
}

export function trackFavoritesToggleView(params) {
  trackEvent('favorites_toggle_view', params);
}

export function getEventAnalyticsParams(event, extra = {}) {
  return {
    event_name: event?.['Event Name'] || '',
    organizer_name: getEventOrganizationName(event),
    event_date: event?.Date || '',
    event_city: event?.Address?.city || '',
    event_source: event?.source || '',
    manual_program_id: event?.manualProgramId || '',
    ...extra,
  };
}

export function trackEventDetailView(event) {
  trackEvent('event_detail_view', getEventAnalyticsParams(event));
}

export function trackEventDetailsClick(event, params = {}) {
  trackEvent('event_details_click', getEventAnalyticsParams(event, params));
}

export function trackTicketClick(event, params = {}) {
  trackEvent('official_ticket_click', getEventAnalyticsParams(event, params));
}

export function trackRelatedEventClick(event, params = {}) {
  trackEvent('related_event_click', getEventAnalyticsParams(event, params));
}
